export const PMAIL_TYPES = {
    general: 'general',
    inviteToApply: 'invite_to_apply',
    inviteToFollow: 'invite_to_follow',
};
